// $(document).on('ready', function () {
//     console.log('--READY--');
//     $(".regular").slick({
//         dots: true,
//         infinite: false,
//         slidesToShow: 1,
//         slidesToScroll: 1
//     });
//     $(".regular-artist").slick({
//         dots: true,
//         infinite: true,
//         slidesToShow: 6,
//         slidesToScroll: 6
//     });
//     $(".center").slick({
//         dots: true,
//         infinite: true,
//         centerMode: true,
//         slidesToShow: 1,
//         slidesToScroll: 3,
//         arrows: false,
//         autoplay: false
//     });
//     $(".variable").slick({
//         dots: true,
//         infinite: true,
//         variableWidth: true
//     });

//     $(".two-cards").slick({
//         dots: true,
//         infinite: true,
//         centerMode: false,
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         arrows: true,
//         autoplay: false
//     });

//     $('.responsive').slick({
//     dots: true,
//     infinite: true,
//     slidesToShow: 6,
//     slidesToScroll: 6,
//     responsive: [
//     {
//         breakpoint: 1199,
//         settings: {
//             slidesToShow: 5,
//             slidesToScroll: 5,
//             infinite: false,
//             dots: true
//         }
//     },        {
//         breakpoint: 991,
//         settings: {
//             slidesToShow: 4,
//             slidesToScroll: 4
//         }
//     },
//     {
//         breakpoint: 767,
//         settings: {
//             slidesToShow: 3,
//             slidesToScroll: 3
//         }
//     },
//     {
//         breakpoint: 479,
//         settings: {
//             slidesToShow: 2,
//             slidesToScroll: 2
//         }
//     }
//     ]
// });

// });




var initCarousel = function() {
    $(".regular").not('.slick-initialized').slick({
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
    });
    $(".regular-artist").not('.slick-initialized').slick({
        dots: true,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 6
    });
    $(".center").not('.slick-initialized').slick({
        dots: true,
        infinite: true,
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 3,
        arrows: false,
        autoplay: false
    });
    $(".variable").not('.slick-initialized').slick({
        dots: true,
        infinite: true,
        variableWidth: true
    });

    $(".two-cards").not('.slick-initialized').slick({
        dots: true,
        infinite: true,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: true,
        autoplay: false
    });
    $('.responsive').not('.slick-initialized').slick(
        {
            dots: true,
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 6,
            responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    infinite: false,
                    dots: true
                }
            },        {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
            ]
        }

    );
}
export default initCarousel
// $('.responsive').slick({
//     dots: true,
//     infinite: true,
//     slidesToShow: 6,
//     slidesToScroll: 6,
//     responsive: [
//     {
//         breakpoint: 1199,
//         settings: {
//             slidesToShow: 5,
//             slidesToScroll: 5,
//             infinite: false,
//             dots: true
//         }
//     },        {
//         breakpoint: 991,
//         settings: {
//             slidesToShow: 4,
//             slidesToScroll: 4
//         }
//     },
//     {
//         breakpoint: 767,
//         settings: {
//             slidesToShow: 3,
//             slidesToScroll: 3
//         }
//     },
//     {
//         breakpoint: 479,
//         settings: {
//             slidesToShow: 2,
//             slidesToScroll: 2
//         }
//     }
//     ]
// });
